import React from "react";
import { Reveal, Eyebrow } from "@/components/ui-bits";

// Shared hero for interior pages (calm editorial rhythm)
export function PageHero({ eyebrow, title, subtitle, image }) {
  return (
    <section className="relative pt-48 pb-24 md:pb-28 overflow-hidden grain">
      <div className="absolute inset-0 radial-blue" />
      {image && (
        <>
          <img src={image} alt="" className="absolute inset-0 h-full w-full object-cover opacity-20" />
          <div className="absolute inset-0 bg-gradient-to-b from-bb-bg/70 via-bb-bg/85 to-bb-bg" />
        </>
      )}
      <div className="relative z-10 mx-auto max-w-[1400px] px-6 lg:px-10">
        <Reveal>
          <Eyebrow>{eyebrow}</Eyebrow>
          <h1 className="mt-8 font-serif font-light text-5xl sm:text-6xl lg:text-7xl tracking-tight leading-[1.05] max-w-5xl">{title}</h1>
          {subtitle && <p className="mt-8 text-lg md:text-xl font-light text-bb-silver/70 max-w-2xl leading-relaxed">{subtitle}</p>}
        </Reveal>
      </div>
    </section>
  );
}

export function Section({ children, className = "" }) {
  return (
    <section className={`mx-auto max-w-[1400px] px-6 lg:px-10 py-24 md:py-32 ${className}`}>
      {children}
    </section>
  );
}

// Alternating image/text editorial block (tracr-style)
export function EditorialSplit({ eyebrow, title, children, image, imageAlt = "", reverse = false, cta }) {
  return (
    <div className="grid lg:grid-cols-2 gap-12 lg:gap-24 items-center">
      <Reveal className={reverse ? "lg:order-2" : ""}>
        <div className="editorial-media relative aspect-[5/4] lg:aspect-[4/5]">
          <img src={image} alt={imageAlt} className="h-full w-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-bb-bg/60 via-transparent to-transparent" />
        </div>
      </Reveal>
      <Reveal delay={0.1} className={reverse ? "lg:order-1" : ""}>
        <div>
          {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
          <h2 className="mt-6 font-serif font-light text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.08]">{title}</h2>
          <div className="mt-8 text-base md:text-lg font-light text-bb-silver/75 leading-relaxed space-y-5">{children}</div>
          {cta}
        </div>
      </Reveal>
    </div>
  );
}
